import { Fieldset, Grid, NumberInput, TextInput } from '@mantine/core';
import type { UseFormReturnType } from '@mantine/form';
import {
	IconArrowDown,
	IconArrowUp,
	IconBasketDollar,
	IconShoppingCartCheck,
} from '@tabler/icons-react';
import { defaultIconStyle } from '../../../theme/styling/iconStyling';

type BulkUpsertProductPriceFormProps = {
	// biome-ignore lint/suspicious/noExplicitAny: <explanation>
	form: UseFormReturnType<any, (values: any) => any>;
};

export function BulkUpdateProductPriceForm({
	form,
}: BulkUpsertProductPriceFormProps) {
	return (
		<>
			<Fieldset legend={'Price'}>
				<Grid>
					<Grid.Col span={12}>
						<NumberInput
							description={
								'Leave blank if you do not want to update the price inc. VAT.'
							}
							label={'Price inc. VAT'}
							placeholder={'Insert price including VAT of products...'}
							key={form.key('incVatPrice')}
							{...form.getInputProps('incVatPrice')}
							decimalScale={2}
							prefix="£"
							leftSection={<IconBasketDollar {...defaultIconStyle} />}
							allowNegative={false}
							thousandSeparator={','}
						/>
					</Grid.Col>
					<Grid.Col span={12}>
						<TextInput
							description={
								'Leave blank if you do not want to update the stock level.'
							}
							label={'Stock Level'}
							placeholder={'Insert stock level of products...'}
							leftSection={<IconShoppingCartCheck {...defaultIconStyle} />}
							key={form.key('stockLevel')}
							{...form.getInputProps('stockLevel')}
						/>
					</Grid.Col>
					<Grid.Col span={6}>
						<NumberInput
							label={'Minimum Stock'}
							description={'Leave blank if you do not want to update the minimum stock.'}
							placeholder={'Insert minimum stock...'}
							key={form.key('minStock')}
							{...form.getInputProps('minStock')}
							leftSection={<IconArrowDown {...defaultIconStyle} />}
							allowDecimal={false}
							thousandSeparator={','}
						/>
					</Grid.Col>
					<Grid.Col span={6}>
						<NumberInput
							label={'Maximum Stock'}
							description={'Leave blank if you do not want to update the maximum stock.'}
							placeholder={'Insert maximum stock...'}
							key={form.key('maxStock')}
							{...form.getInputProps('maxStock')}
							leftSection={<IconArrowUp {...defaultIconStyle} />}
							allowDecimal={false}
							thousandSeparator={','}
						/>
					</Grid.Col>
				</Grid>
			</Fieldset>
		</>
	);
}
